import { memo } from "react";
import type { ListChildComponentProps } from "react-window";
import { areEqual } from "react-window";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";
import { WORD_STATUS, type WordStatus, type WordsListItemData } from "./types";

export function StatusIcon({ status }: { status: WordStatus }) {
  switch (status) {
    case WORD_STATUS.TRANSLATED:
      return <CheckCircleOutlineIcon color="success" />;
    case WORD_STATUS.CHANGED:
      return <EditOutlinedIcon color="warning" />;
    case WORD_STATUS.UNTRANSLATED:
    default:
      return <ErrorOutlineIcon color="error" />;
  }
}

export const WordRow = memo(function WordRow({
  data,
  index,
  style,
}: ListChildComponentProps<WordsListItemData>) {
  const { words, onClickItem, onClickDelete, onClickRestore } = data;
  const word = words[index];

  return (
    <ListItem style={style} disablePadding dense>
      <ListItemButton
        selected={word.selected}
        onClick={() => onClickItem(word)}
        sx={{ height: "100%" }}
      >
        <ListItemIcon>
          <StatusIcon status={word.status} />
        </ListItemIcon>
        <ListItemText
          primary={
            <span
              style={{
                textDecoration: word.deleted ? "line-through" : undefined,
              }}
            >
              {word.key}
            </span>
          }
          secondary={word.label}
          slotProps={{ primary: { noWrap: true }, secondary: { noWrap: true } }}
        />
        {word.deleted ? (
          <Tooltip title="Восстановить ключ">
            <IconButton
              edge="end"
              onClick={(event) => {
                event.stopPropagation();
                onClickRestore(word);
              }}
            >
              <ReplayIcon color="disabled" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Удалить ключ">
            <IconButton
              edge="end"
              onClick={(event) => {
                event.stopPropagation();
                onClickDelete(word);
              }}
            >
              <DeleteIcon color="disabled" />
            </IconButton>
          </Tooltip>
        )}
      </ListItemButton>
    </ListItem>
  );
}, areEqual);
